// 模块化vuex数据
// getter调用示例：this.$store.getters['moduleA/moduleState']

const state = {
  videoData: {}, // File
  videoUrl: {}, // 相对路径
  videoUrlShot: {},
  videoInfo: {} // 服务器视频信息
};

const getters = {
  videoData: (state) => state.videoData,
  videoUrl: (state) => state.videoUrl,
  videoUrlShot: (state) => state.videoUrlShot,
  videoInfo: (state) => state.videoInfo
};

const mutations = {
  setVideoData(state, data) {
    state.videoData = data;
  },
  setVideoUrl(state, data) {
    state.videoUrlShot = {};
    state.videoUrl = data;
  },
  setVideoUrlShot(state, data) {
    state.videoUrlShot = {
      ...state.videoUrlShot,
      ...data
    };
  },
  setVideoInfo(state, data) {
    state.videoInfo = {
      ...state.videoInfo,
      data
    };
  }
};

const actions = {
  async upload(store, payload) {
    store, payload;
  },
  async storeMaterial() {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
